import * as React from "react";
import FeatureCard from "./FeatureCard";

function FeaturesGrid({ features }) {
  return (
    <section className="grid grid-cols-4 gap-6 max-md:grid-cols-2 max-sm:grid-cols-1 mx-8">
      {features.map((feature, index) => (
        <FeatureCard
          key={index}
          image={feature.image}
          altText={feature.altText}
          title={feature.title}
          description={feature.description}
        />
      ))}
    </section>
  );
}

export default FeaturesGrid;
